export default __webpack_public_path__ + "static/media/043-distribution.deadb96c.png";